import React from "react";
import {Route, Routes, Navigate} from "react-router";
import {About} from "./About";
import {LandingPage} from "./LandingPage";
import {ForRegularPersons} from "./ForRegularPersons";
import {Admin} from "../admin/Admin";
import {ForProfessionals} from "./ForProfessionals";
import {Meditation} from "./Meditation";
import {OrderBooks} from "../book/OrderBooks";
import {Email} from "../admin/Email";
import {Login} from "../header/Login";
import {Me} from "../profile/Me";
import {Folders} from "../folder/Folders";
import {Users} from "../user/Users";
import {InstructorProfilePage} from "../profile/InstructorProfilePage";
import {NewsPage} from "../news/NewsPage";
import {ArticlePage} from "../news/ArticlePage";
import {AdminNews} from "../admin/AdminNews";
import {AdminTestimonials} from "../admin/AdminTestimonials";
import {AdminInstructorTraining} from "../admin/AdminInstructorTraining";
import {AdminBookOrders} from "../admin/AdminBookOrders";
import {UnifiedCalendarPage} from "../calendar/UnifiedCalendarPage";

export const AppRoutes = () => {
    return (
        <>
            <Routes>
                <Route
                    exact
                    path={"/"}
                    element={<LandingPage />}
                />
                <Route
                    exact
                    path={"/calendar"}
                    element={<UnifiedCalendarPage />}
                />
                <Route
                    exact
                    path={"/kurskalender"}
                    element={<UnifiedCalendarPage />}
                />
                <Route
                    exact
                    path={"/about"}
                    element={<About />}
                />
                <Route
                    exact
                    path={"/find-instructor"}
                    element={<ForRegularPersons />}
                />
                <Route
                    exact
                    path={"/regular"}
                    element={<ForRegularPersons />}
                />
                <Route
                    exact
                    path={"/get-educated"}
                    element={<ForProfessionals />}
                />
                <Route
                    exact
                    path={"/for-fagfolk"}
                    element={<Navigate to="/get-educated" replace />}
                />
                <Route
                    exact
                    path ="/meditation"
                    element={<Meditation />}
                />
                <Route
                    exact
                    path={"/order-books"}
                    element={<OrderBooks />}
                />
                <Route
                    exact
                    path={"/news"}
                    element={<NewsPage />}
                />
                <Route
                    exact
                    path={"/nyheter/:articleId"}
                    element={<ArticlePage />}
                />
                <Route
                    exact
                    path={"/news/:articleId"}
                    element={<ArticlePage />}
                />
                <Route
                    exact
                    path={"/admin/orders"}
                    element={<AdminBookOrders />}
                />
                <Route
                    exact
                    path={"/admin/bokbestillinger"}
                    element={<AdminBookOrders />}
                />
                <Route
                    exact
                    path={"/admin/news"}
                    element={<AdminNews />}
                />
                <Route
                    exact
                    path={"/admin/testimonials"}
                    element={<AdminTestimonials />}
                />
                <Route
                    exact
                    path={"/admin/training"}
                    element={<AdminInstructorTraining />}
                />
                <Route
                    exact
                    path={"/admin/kurslederopplaering"}
                    element={<AdminInstructorTraining />}
                />
                <Route
                    exact
                    path={"/administrate-instructors"}
                    element={<Admin />}
                />
                <Route
                    exact
                    path={"/admin/users"}
                    element={<Users />}
                />
                <Route
                    exact
                    path={"/send-email-to-instructors"}
                    element={<Email />}
                />
                <Route
                    path={"/login"}
                    element={<Login />}
                />
                <Route
                    path={"/me"}
                    element={<Me />}
                />
                <Route
                    path={"/files"}
                    element={<Folders />}
                />
                <Route
                    path={"/instructor-profile"}
                    element={<InstructorProfilePage />}
                />
            </Routes>
        </>
    )
}